module.exports = __webpack_public_path__ + "static/media/localhackday.1142520d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/localhackday.svg
// module id = 844
// module chunks = 0